import { render, staticRenderFns } from "./SimpleFilterWidget.vue?vue&type=template&id=44892109&scoped=true&"
import script from "./SimpleFilterWidget.vue?vue&type=script&lang=js&"
export * from "./SimpleFilterWidget.vue?vue&type=script&lang=js&"
import style0 from "./SimpleFilterWidget.vue?vue&type=style&index=0&id=44892109&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44892109",
  null
  
)

export default component.exports